import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
    Target, Award, Trophy, Medal, Star, BookOpen, GraduationCap,
    BarChart3, TrendingUp, DollarSign, Briefcase, Users, Building2,
    Globe, Gift, Gem, FileText, FolderOpen, Laptop, Sparkles,
    Cloud, MapPin, Sun, Banknote, ExternalLink, Database, CircleDot,
    Palmtree, Heart, ThumbsUp, Crown, Coins, CreditCard, PiggyBank,
    Percent, Calendar, Clock, CheckCircle, Settings, Search, Mail,
    Phone, Video, Image, Mic, Headphones, Shield, Zap, Rocket,
    Flag, Compass, Lightbulb, Handshake, Megaphone, LayoutGrid,
    Layers, Tag, Bookmark, Home, Link, X, ChevronDown
} from 'lucide-react';
import './LucideIconPicker.css';

const ICON_LIST = [
    { name: 'Target', component: Target, keywords: ['목표', '타겟', 'target'] },
    { name: 'Award', component: Award, keywords: ['상', '수상', 'award'] },
    { name: 'Trophy', component: Trophy, keywords: ['트로피', '우승', 'trophy'] },
    { name: 'Medal', component: Medal, keywords: ['메달', '훈장', 'medal'] },
    { name: 'Star', component: Star, keywords: ['별', '스타', 'star'] },
    { name: 'BookOpen', component: BookOpen, keywords: ['책', '교육', 'book'] },
    { name: 'GraduationCap', component: GraduationCap, keywords: ['졸업', '교육', 'education'] },
    { name: 'BarChart3', component: BarChart3, keywords: ['차트', '통계', 'chart'] },
    { name: 'TrendingUp', component: TrendingUp, keywords: ['상승', '성장', 'trending'] },
    { name: 'DollarSign', component: DollarSign, keywords: ['달러', '돈', 'dollar'] },
    { name: 'Briefcase', component: Briefcase, keywords: ['서류가방', '비즈니스', 'business'] },
    { name: 'Users', component: Users, keywords: ['사용자', '팀', 'users', 'team'] },
    { name: 'Building2', component: Building2, keywords: ['건물', '회사', 'building'] },
    { name: 'Globe', component: Globe, keywords: ['글로벌', '지구', 'globe'] },
    { name: 'Gift', component: Gift, keywords: ['선물', '보상', 'gift'] },
    { name: 'Gem', component: Gem, keywords: ['보석', '다이아몬드', 'gem'] },
    { name: 'FileText', component: FileText, keywords: ['파일', '문서', 'file', 'document'] },
    { name: 'FolderOpen', component: FolderOpen, keywords: ['폴더', '자료', 'folder'] },
    { name: 'Laptop', component: Laptop, keywords: ['노트북', '컴퓨터', 'laptop'] },
    { name: 'Sparkles', component: Sparkles, keywords: ['반짝', '새로운', 'new', 'sparkle'] },
    { name: 'Cloud', component: Cloud, keywords: ['클라우드', '구름', 'cloud'] },
    { name: 'MapPin', component: MapPin, keywords: ['위치', '지도', 'map', 'location'] },
    { name: 'Sun', component: Sun, keywords: ['태양', '밝은', 'sun'] },
    { name: 'Banknote', component: Banknote, keywords: ['지폐', '돈', 'money'] },
    { name: 'ExternalLink', component: ExternalLink, keywords: ['링크', '외부', 'link'] },
    { name: 'Database', component: Database, keywords: ['데이터베이스', 'DB', 'database'] },
    { name: 'CircleDot', component: CircleDot, keywords: ['원', '점', 'circle'] },
    { name: 'Palmtree', component: Palmtree, keywords: ['야자수', '여행', 'palm', 'travel'] },
    { name: 'Heart', component: Heart, keywords: ['하트', '좋아요', 'heart'] },
    { name: 'ThumbsUp', component: ThumbsUp, keywords: ['좋아요', '추천', 'like'] },
    { name: 'Crown', component: Crown, keywords: ['왕관', '1등', 'crown'] },
    { name: 'Coins', component: Coins, keywords: ['동전', '코인', 'coins'] },
    { name: 'CreditCard', component: CreditCard, keywords: ['카드', '결제', 'card'] },
    { name: 'PiggyBank', component: PiggyBank, keywords: ['저금통', '저축', 'savings'] },
    { name: 'Percent', component: Percent, keywords: ['퍼센트', '할인', 'percent'] },
    { name: 'Calendar', component: Calendar, keywords: ['달력', '일정', 'calendar'] },
    { name: 'Clock', component: Clock, keywords: ['시계', '시간', 'clock'] },
    { name: 'CheckCircle', component: CheckCircle, keywords: ['확인', '완료', 'check'] },
    { name: 'Settings', component: Settings, keywords: ['설정', '관리', 'settings'] },
    { name: 'Search', component: Search, keywords: ['검색', '찾기', 'search'] },
    { name: 'Mail', component: Mail, keywords: ['메일', '이메일', 'mail'] },
    { name: 'Phone', component: Phone, keywords: ['전화', '연락', 'phone'] },
    { name: 'Video', component: Video, keywords: ['비디오', '영상', 'video'] },
    { name: 'Image', component: Image, keywords: ['이미지', '사진', 'image'] },
    { name: 'Mic', component: Mic, keywords: ['마이크', '녹음', 'mic'] },
    { name: 'Headphones', component: Headphones, keywords: ['헤드폰', '음악', 'headphones'] },
    { name: 'Shield', component: Shield, keywords: ['보안', '방패', 'shield'] },
    { name: 'Zap', component: Zap, keywords: ['번개', '빠른', 'fast'] },
    { name: 'Rocket', component: Rocket, keywords: ['로켓', '성장', 'rocket'] },
    { name: 'Flag', component: Flag, keywords: ['깃발', '목표', 'flag'] },
    { name: 'Compass', component: Compass, keywords: ['나침반', '방향', 'compass'] },
    { name: 'Lightbulb', component: Lightbulb, keywords: ['전구', '아이디어', 'idea'] },
    { name: 'Handshake', component: Handshake, keywords: ['악수', '협력', 'handshake'] },
    { name: 'Megaphone', component: Megaphone, keywords: ['확성기', '공지', 'announce'] },
    { name: 'LayoutGrid', component: LayoutGrid, keywords: ['그리드', '레이아웃', 'grid'] },
    { name: 'Layers', component: Layers, keywords: ['레이어', '계층', 'layers'] },
    { name: 'Tag', component: Tag, keywords: ['태그', '라벨', 'tag'] },
    { name: 'Bookmark', component: Bookmark, keywords: ['북마크', '즐겨찾기', 'bookmark'] },
    { name: 'Home', component: Home, keywords: ['홈', '집', 'home'] },
    { name: 'Link', component: Link, keywords: ['링크', '연결', 'link'] },
];

// 아이콘 이름 → 컴포넌트 매핑 (외부에서 재사용 가능)
export const LUCIDE_ICON_MAP = {};
ICON_LIST.forEach(({ name, component }) => {
    LUCIDE_ICON_MAP[name] = component;
});

function LucideIconPicker({ value, onChange }) {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');
    const containerRef = useRef(null);
    const searchInputRef = useRef(null);

    // 외부 클릭 시 드롭다운 닫기
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);

    // 드롭다운 열릴 때 검색 입력에 포커스
    useEffect(() => {
        if (isOpen && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [isOpen]);

    // 검색 필터링
    const filteredIcons = useMemo(() => {
        if (!search.trim()) return ICON_LIST;
        const query = search.toLowerCase().trim();
        return ICON_LIST.filter(({ name, keywords }) =>
            name.toLowerCase().includes(query) ||
            keywords.some(kw => kw.toLowerCase().includes(query))
        );
    }, [search]);

    // 현재 선택된 아이콘 찾기
    const selectedIcon = ICON_LIST.find(icon => icon.name === value);

    const handleSelect = (iconName) => {
        onChange(iconName);
        setIsOpen(false);
        setSearch('');
    };

    const handleClear = (e) => {
        e.stopPropagation();
        onChange(null);
        setIsOpen(false);
        setSearch('');
    };

    const handleToggle = () => {
        setIsOpen(prev => !prev);
        if (isOpen) setSearch('');
    };

    return (
        <div className="lucide-icon-picker" ref={containerRef}>
            <button
                type="button"
                className={`icon-picker-trigger ${isOpen ? 'active' : ''}`}
                onClick={handleToggle}
            >
                {selectedIcon ? (
                    <span className="icon-picker-selected">
                        <selectedIcon.component size={18} />
                        <span className="icon-picker-selected-name">{selectedIcon.name}</span>
                        <span className="icon-picker-clear" onClick={handleClear} title="선택 해제">
                            <X size={14} />
                        </span>
                    </span>
                ) : (
                    <span className="icon-picker-placeholder">
                        <span>아이콘 선택</span>
                        <ChevronDown size={16} />
                    </span>
                )}
            </button>

            {isOpen && (
                <div className="icon-picker-dropdown">
                    <div className="icon-picker-search">
                        <Search size={14} className="icon-picker-search-icon" />
                        <input
                            ref={searchInputRef}
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="아이콘 검색..."
                        />
                    </div>
                    <div className="icon-picker-grid">
                        {filteredIcons.length > 0 ? (
                            filteredIcons.map(({ name, component: IconComp }) => (
                                <button
                                    key={name}
                                    type="button"
                                    className={`icon-picker-item ${value === name ? 'selected' : ''}`}
                                    onClick={() => handleSelect(name)}
                                    title={name}
                                >
                                    <IconComp size={20} />
                                </button>
                            ))
                        ) : (
                            <div className="icon-picker-empty">검색 결과가 없습니다</div>
                        )}
                    </div>
                    {value && (
                        <button
                            type="button"
                            className="icon-picker-clear-btn"
                            onClick={handleClear}
                        >
                            선택 해제
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}

export default LucideIconPicker;
